import { SetOther } from './typings'

export const setOtherActionCreator = (payload: string): SetOther => ({
  type: 'referrals/setOther',
  payload,
})
